import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";

export default class ProgressBarModal extends Component {
    handleCloseModalClick = () => {
        this.props.closeProgressBarModal();
    };

    getPreparingFileBar = (fileName) => {
        return (
            <div key={fileName}>
                <div className="col-12 flex color-primary">
                    <h5 className="col-6">{fileName}</h5>
                    <h5 className="col-6 text-align-right">
                        <Translate value="rccDialog.145" />
                    </h5>
                </div>
                <div className="progress progress-dark col-12">
                    <div
                        className="progress-bar"
                        style={{width: 0 + "%"}}
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    />
                </div>
            </div>
        );
    };

    getProgressBar = (file) => {
        let progress = formatHelper.formatFixedDecimal(
            formatHelper.convertDecimalToPercent(file.downloadedLength / file.totalLength),
            0
        );

        return (
            <div key={file.fileName}>
                <div className="col-12 flex color-primary">
                    <h5 className="col-6">{file.fileName}</h5>
                    <h5 className="col-6 text-align-right">{progress} %</h5>
                </div>
                <div className="progress progress-dark col-12">
                    <div
                        className="progress-bar"
                        style={{width: progress + "%"}}
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    />
                </div>
            </div>
        );
    };

    getProgressInfo = () => {
        let downloadingProgressBars = [];

        let file;
        for (file of this.props.downloadingFileList) {
            if (file.totalLength > 0) {
                if (file.id > 0) {
                    downloadingProgressBars.push(this.getProgressBar(file));
                } else {
                    downloadingProgressBars.push(this.getPreparingFileBar(file.fileName));
                }
            }
        }

        for (file of this.props.downloadingFileListRcc) {
            if (file.totalLength > 0) {
                downloadingProgressBars.push(this.getProgressBar(file));
            }
        }

        if (downloadingProgressBars.length === 0) {
            return <span className="font-size-1_25em">{translate("help.environment.downloadListEmpty")}</span>;
        }

        return downloadingProgressBars;
    };

    getContent = () => {
        return modelHelper.buildModalSection(<div className="col-12 padding-bottom-10">{this.getProgressInfo()}</div>);
    };

    render() {
        return (
            <Modal
                tabId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.downloadingFile" />)}
                content={this.getContent()}
                styles={{minWidth: "35%"}}
            />
        );
    }
}
